<script>
  import { onMount } from 'svelte';
  import store from './YarnFillTableStore';

  export let repeats = [];
  let elements = [];
  let hasInited = false;
  $: repeatRows = [[]];
  $: repeatTimesPerRow = [];
  $: selectedRepeat = undefined;
  $: amountOfNumberInputs = [];
  $: width = $store.width;
  $: {
    setAmountOfNumberInputs(repeatRows);
  }
  $: {
    repeats = [];
    for (let i = 0; i < repeatRows.length; i++) {
      let rep = getRepeats(repeatRows[i], repeatTimesPerRow[i]);
      if (rep.length > 0) {
        repeats[i] = rep;
      }
    }
  }

  $: {
    if (hasInited) {
      store.update((temp) => {
        temp.repeatRows = JSON.parse(JSON.stringify(repeatRows));
      });
    }
  }

  $: {
    if (hasInited) {
      store.update((temp) => {
        temp.repeatTimesPerRow = JSON.parse(JSON.stringify(repeatTimesPerRow));
      });
    }
  }

  /*
  $: {
    repeatRows.forEach((r) => console.log(r.join('')));
    console.log('');
  }
  */

  onMount(() => {
    repeatRows = JSON.parse(JSON.stringify($store.repeatRows));
    repeatTimesPerRow = JSON.parse(JSON.stringify($store.repeatTimesPerRow));
    setAmountOfNumberInputs(repeatRows);
    hasInited = true;
  });

  function setAmountOfNumberInputs(rows) {
    amountOfNumberInputs = [];
    for (let i = 0; i < rows.length; i++) {
      let ids = getIds(i);
      amountOfNumberInputs[i] = [];
      ids.forEach((id) => {
        amountOfNumberInputs[i].push(id);
      });
    }
    amountOfNumberInputs = [...amountOfNumberInputs];
  }

  export function insertColumn(index) {
    for (let i = 0; i < repeatRows.length; i++) {
      if (index < repeatRows[i].length - 1) {
        repeatRows[i].splice(index, 0, repeatRows[i][index]);
      } else {
        repeatRows[i].push(0);
      }
    }
    repeatRows = [...repeatRows];
  }

  export function removeColumn(index) {
    for (let i = 0; i < repeatRows.length; i++) {
      repeatRows[i].splice(index, 1);
      postChangeCheck(repeatRows[i]);
    }
    repeatRows = [...repeatRows];
  }

  let distanceBetweenPoints;
  let firstTDWidth;
  let fromRow;
  let fromColumn;
  let startX;
  let startClientX;
  let elementActive = false;
  let hasDragged;
  function dragStart(event, row, column) {
    //elementActive = false;
    hasDragged = false;
    fromRow = row;
    fromColumn = column;
    startX = event.target.getBoundingClientRect().x;
    startClientX = event.clientX;
    distanceBetweenPoints = getDistanceBetweenPoints();
    document.body.classList.add('dragging');
    document.addEventListener('mousemove', dragMove);
    document.addEventListener('pointerup', dragEnd, { once: true });
  }

  let lastX;
  let lastFromRow;
  let lastFromColumn;
  function dragEnd(event) {
    let delta = event.clientX - startClientX;
    if (delta < 8) {
      //Set active element here for mouse clicking action (non-dragging)
      if (elementActive && fromRow === lastFromRow) {
        startX = lastX;
        fromRow = lastFromRow;
        fromColumn = lastFromColumn;
        dragMove(event);
        elementActive = false;
      } else if (hasDragged === false) {
        lastX = startX;
        lastFromRow = fromRow;
        lastFromColumn = fromColumn;
        elementActive = true;
      }
    }
    document.body.classList.remove('dragging');
    document.removeEventListener('mousemove', dragMove);
  }

  function dragMove(event) {
    let x = event.clientX;
    let row = repeatRows[fromRow];
    let delta = Math.round((x - startX) / distanceBetweenPoints);

    if (
      Number.isNaN(delta) ||
      delta === 0 ||
      fromColumn + delta < 0 ||
      fromColumn + delta > width - 1
    ) {
      return;
    }
    hasDragged = true;
    let id = row[fromColumn];
    if (delta !== 0) {
      while (
        delta !== 0 &&
        encompassUnitInRowAbove(id, fromColumn, delta, fromRow)
      ) {
        let change = Math.sign(delta);
        id = modifyRepeat(id, fromRow, change, fromColumn);
        fromColumn += change;
        startX += distanceBetweenPoints * change;
        delta -= change;
      }
      postChangeCheck();
      repeatRows[fromRow] = row;
      repeatRows = [...repeatRows];
    }
  }

  function isEndpoint(position, rowNum) {
    let row = repeatRows[rowNum];
    let id = row[position];
    if (
      row[position - 1] !== id ||
      row[position + 1] !== id ||
      position === 0 ||
      position === row.length - 1
    ) {
      return true;
    }
    return false;
  }

  function encompassUnitInRowAbove(id, fromColumn, delta, fromRow) {
    if (fromRow === 0) {
      return true;
    }
    let row = repeatRows[fromRow - 1];
    let currentRow = repeatRows[fromRow];
    let repeats = getRepeats(row);
    let target = fromColumn + delta;
    if (target === 0) {
      return true;
    }
    if (row[target] === 0 || target === row.length - 1) {
      return true;
    }
    if (isEndpoint(target, fromRow) && currentRow[target] === id) {
      return true;
    }
    for (let rep of repeats) {
      if (currentRow[target] !== id || id === 0) {
        if (delta > 0 && target === rep.to) {
          return true;
        }
        if (delta < 0 && target === rep.from) {
          return true;
        }
      } else {
        if (delta > 0 && target === rep.from) {
          return true;
        }
        if (delta < 0 && target === rep.to) {
          return true;
        }
      }
    }
    return false;
  }

  function getRepeats(row, repeatTimes = []) {
    let lastValue = -1;
    let repeats = [];
    for (let i = 0; i < row.length; i++) {
      if (lastValue !== row[i]) {
        if (repeats.length > 0) {
          repeats[repeats.length - 1].to = i - 1;
        }
        repeats.push({ from: i, times: repeatTimes[row[i]], id: row[i] });
        lastValue = row[i];
      }
    }
    if (repeats.length > 0 && repeats[repeats.length - 1].to === undefined) {
      repeats[repeats.length - 1].to = row.length - 1;
    }
    return repeats.filter((r) => r.id !== 0);
  }

  function getIds(row) {
    return new Set(repeatRows[row].filter((a) => a !== 0));
  }

  function generateId(row) {
    return repeatRows[row].reduce((a, b) => Math.max(a, b)) + 1;
  }

  function modifyRepeat(id, rowNumber, delta, position) {
    let row = repeatRows[rowNumber];
    if (id === 0) {
      id = generateId(fromRow);
      row[position] = id;
      if (repeatTimesPerRow[fromRow] === undefined) {
        repeatTimesPerRow[fromRow] = [];
      }
      repeatTimesPerRow[fromRow][id] = 1;
      repeatTimesPerRow = [...repeatTimesPerRow];
    }
    if (row[position + delta] !== id) {
      row[position + delta] = id;
      // If a repeat increases we must increase on rows below to prevent invalid state
      for (let i = rowNumber + 1; i < repeatRows.length; i++) {
        let subRow = repeatRows[i];
        if (subRow[position] !== subRow[position + delta]) {
          subRow[position + delta] = subRow[position];
        }
      }
    } else {
      // Decrease does not have the same problem with invalidation as increases
      row[position] = 0;
    }
    return id;
  }

  function postChangeCheck() {
    for (let row of repeatRows) {
      // Remove 1-length repeats
      for (let i = 1; i < row.length - 1; i++) {
        let pre = row[i - 1];
        let id = row[i];
        let post = row[i + 1];
        if (pre !== id && post !== id) {
          row[i] = 0;
        }
      }
      //Remove 1-length from both ends
      if (row[0] !== row[1]) {
        row[0] = 0;
      }
      if (row[row.length - 1] !== row[row.length - 2]) {
        row[row.length - 1] = 0;
      }
    }
    let lastRow = repeatRows[repeatRows.length - 1];
    //If last row has repeats, add row with zeroes
    if (lastRow.some((v) => v !== 0)) {
      repeatRows.push(Array(width).fill(0));
      repeatTimesPerRow.push([]);
      //If two last rows are all zeroes, remove one.
    }
    if (repeatRows.length > 1) {
      let secondToLastRow = repeatRows[repeatRows.length - 2];
      if (
        (lastRow.every((v) => v === 0) &&
          secondToLastRow.every((v) => v === 0)) ||
        (secondToLastRow[0] !== 0 &&
          secondToLastRow.every((v) => v === secondToLastRow[0]))
      ) {
        repeatRows.length = repeatRows.length - 1;
      }
    }
  }

  function getPositionOfNumberInput(id, row) {
    let start = -1;
    let length = 0;
    for (let i = 0; i < repeatRows[row].length; i++) {
      let rowId = repeatRows[row][i];
      if (rowId === id) {
        if (start === -1) {
          start = i;
          length = 1;
        } else {
          length++;
        }
      }
    }
    return (start + length / 2) * distanceBetweenPoints + firstTDWidth;
  }

  function getDistanceBetweenPoints() {
    if (
      elements !== undefined &&
      elements[0] !== undefined &&
      elements[0].firstChild !== undefined
    ) {
      let elm = elements[0];
      let totalWidth = elm.getBoundingClientRect().width;
      firstTDWidth = elm.firstChild.getBoundingClientRect().width;
      let repeatWidths = totalWidth - firstTDWidth;
      return repeatWidths / width;
    } else {
      return 1;
    }
  }

  function setRepeatTimes(id, row, value) {
    repeatTimesPerRow[row][id] = value;
    repeatTimesPerRow = [...repeatTimesPerRow];
  }

  function showRepeatDragMarker(row, column, selectedRepeatId) {
    return (
      row[column - 1] !== row[column] ||
      row[column + 1] !== row[column] ||
      row[column] === 0 ||
      (selectedRepeatId !== undefined &&
        (row[column] === 0 || selectedRepeatId === row[column]))
    );
  }

  function getRepeatTimesValue(row, id) {
    return repeatTimesPerRow[row][id];
  }
</script>

{#if width > 1}
  {#each repeatRows as repeatRow, row}
    <tr class="repeat" bind:this={elements[row]}>
      <td />

      {#each { length: width } as _, column}
        <td>
          <div class="repeat-container">
            <div
              class="line left"
              class:visible={repeatRows[row][column] !== 0 &&
                repeatRows[row][column - 1] !== 0 &&
                repeatRows[row][column] === repeatRows[row][column - 1]}
            />
            {#if showRepeatDragMarker(repeatRows[row], column, selectedRepeat?.id)}
              <button
                class:active={fromColumn === column &&
                  fromRow === row &&
                  elementActive}
                data-id={repeatRows[row][column]}
                data-row={row}
                on:pointerdown={(event) => dragStart(event, row, column)}
              />
            {/if}
            <div
              class="line right"
              class:visible={repeatRows[row][column] !== 0 &&
                repeatRows[row][column] !== 0 &&
                repeatRows[row][column] === repeatRows[row][column + 1]}
            />
          </div>
        </td>
      {/each}
      <div>
        {#each amountOfNumberInputs[row] as id}
          <input
            type="text"
            class="times-input"
            style={`left: calc(${getPositionOfNumberInput(id, row)}px - 1em)`}
            on:input={(e) => setRepeatTimes(id, row, Number(e.target.value))}
            data-id={id}
            data-row={row}
            value={getRepeatTimesValue(row, id)}
          />
        {/each}
      </div>
    </tr>
  {/each}
{/if}

<style>
  .repeat td {
    padding: 0;
  }
  .repeat {
    position: relative;
  }
  .repeat-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 4px;
    margin-bottom: 8px;
  }
  .repeat-container .line {
    flex-grow: 1;
    background-color: black;
    height: 4px;
    visibility: hidden;
  }
  .repeat-container .line.visible {
    visibility: visible;
  }
  .repeat .repeat-container button {
    margin: 0;
    padding: 0;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    border: 4px solid black;
    background-color: black;
  }
  .repeat .repeat-container button:hover,
  .repeat .repeat-container button.active {
    background-color: white;
    cursor: -webkit-grab;
    cursor: grab;
  }
  .repeat,
  .repeat td {
    border: 0;
  }
  .times-input {
    position: absolute;
    width: 2em;
    margin: 0;
    padding: 0;
    text-align: center;
    background-color: white;
    border: 1px solid black;
  }
</style>
